import { ContractStatus } from './types';

// Two-phase review:
//   draft → internal_review (Privion-side approval)
//     → client_review (out to client; redlining happens in Outlook)
//       → signature (out for signing — Zoho Sign later)
//         → executed
// Allow moving back to draft from any state for edits, since real
// negotiations bounce around.
export const STATE_TRANSITIONS: Record<ContractStatus, ContractStatus[]> = {
  draft:           ['internal_review', 'archived'],
  internal_review: ['draft', 'client_review', 'archived'],
  client_review:   ['draft', 'internal_review', 'signature', 'archived'],
  signature:       ['draft', 'client_review', 'executed', 'archived'],
  executed:        ['draft', 'archived'],
  archived:        ['draft'],
};

export function canTransition(from: ContractStatus, to: ContractStatus): boolean {
  return STATE_TRANSITIONS[from]?.includes(to) ?? false;
}

export function getNextStates(current: ContractStatus): ContractStatus[] {
  return STATE_TRANSITIONS[current] ?? [];
}

export function validateTransition(from: ContractStatus, to: ContractStatus): void {
  if (!canTransition(from, to)) {
    throw new Error(
      `Invalid state transition: cannot move from "${from}" to "${to}"`
    );
  }
}
